import { changeIntegrationPreventLanguages } from 'actions/integrationSettings';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getIntegrationSettingsForm } from 'selectors/integrationSettings';
import { useSelector } from 'store';

const PreventLanguages: React.FC = () => {
  const dispatch = useDispatch();

  const { languages_for_better_prevent: preventLanguages } = useSelector(
    getIntegrationSettingsForm
  );

  const handleChangeLanguages = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    dispatch(changeIntegrationPreventLanguages(e.target.value));
  };

  return (
    <div className="flex flex-col gap-1 bg-white">
      <div className="flex flex-row">
        <span>What languages are needed for a better Prevent experience?</span>
      </div>

      <div className="w-full">
        <textarea
          id="investigation-create-objective"
          rows={3}
          className="form-input w-full text-litlingo-gray-6 text-body resize-none"
          value={preventLanguages}
          onChange={handleChangeLanguages}
        />
      </div>
    </div>
  );
};

export default PreventLanguages;
